import React, { useEffect, useRef, useState } from "react";
import example from "../../assets/video/introducing.mp4";
import playButton from "../../assets/images/home/playButton.svg";
import on from "../../assets/images/home/On.svg";
import off from "../../assets/images/home/Off.svg";
import FadeUp from "component/FadeUp/FadeUp";
// import introducing from "../../assets/images/home/video_placeholder.png";

const Neo = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  //   const [checkVideoShow, setCheckVideoShow] = useState(false);
  const [showPlayButton, setShowPlayButton] = useState(false);
  const [videoPlayedOnce, setVideoPlayedOnce] = useState(false);
  const [mute, setMute] = useState(true);
  const swiperRef = useRef(null);

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        //   videoRef.current.currentTime = 0;
        videoRef.current.muted = mute;
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const totalHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = (scrollPosition / totalHeight) * 100;

    if (scrollPercentage >= 7 && videoPlayedOnce) {
      // setCheckVideoShow(true);
    } else {
      // setCheckVideoShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleVideoEnd = () => {
    setIsPlaying(false);
    swiperRef.current?.autoplay?.stop();
    setShowPlayButton(true);
    setVideoPlayedOnce(true);
  };

  return (
    <section className="neo">
      <div className="container neoContainer">
        <div className="common-heading">
          <h1 className="topToBottom">Introducing Neo 1</h1>
          <FadeUp>
            <p className="introductionContent">
              India’s first AI-Native wearable that tracks conversations and
              analyses emotions, unlocking unlimited memory to make you
              Superhuman.
            </p>
          </FadeUp>
        </div>
        <div className="introducing " onClick={togglePlayPause}>
          {/* {checkVideoShow ? (
            <video
              ref={videoRef}
              className="recipe"
              width="100%"
              loop
              playsInline
              preload="auto"
              autoPlay
              muted
            >
              <source src={example} type="video/mp4" />
            </video>
          ) : (
            <img src={introducing} alt="Play button" />
          )} */}

          {/* {checkVideoShow && (
            <video
              ref={videoRef}
              className="recipe"
              width="100%"
              //   loop
              playsInline
              preload="auto"
              autoPlay
              muted
              onEnded={handleVideoEnd}
            >
              <source src={example} type="video/mp4" />
            </video>
          )} */}
          <video
            ref={videoRef}
            className="recipe"
            width="100%"
            //   loop
            playsInline
            preload="auto"
            autoPlay
            muted
            onEnded={handleVideoEnd}
          >
            <source src={example} type="video/mp4" />
          </video>

          {!isPlaying && showPlayButton && (
            <div className="playPauseButton" onClick={togglePlayPause}>
              <img src={playButton} alt="Play button" />
            </div>
          )}
          {
            <div
              className="onOffBox"
              onClick={(e) => {
                e.stopPropagation();
                if (!mute) {
                  videoRef.current.muted = true;
                  setMute(true);
                } else {
                  videoRef.current.muted = false;
                  setMute(false);
                }
              }}
            >
              <img src={mute ? off : on} alt="speaker" />
            </div>
          }
        </div>
      </div>
    </section>
  );
};

export default Neo;
